import { guestOperationsBookingsRoutes } from '@/app/modules/bookings/guestOperations/guest-operations-bookings.routes';

export const BookingsRoutes = guestOperationsBookingsRoutes;
